import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import { ShopProvider } from './context/ShopContext';
import { BillingProvider } from './context/BillingContext';
import { AdminProvider } from './context/AdminContext';
import { BaristaSettingsProvider } from './context/BaristaSettingsContext';
import { CurrencyProvider } from './context/CurrencyContext';
import { BrandProvider } from './context/BrandContext';
import Landing from './pages/Landing'; // Main landing page (formerly LandingV2)
import Login from './pages/Login';
import Register from './pages/Register';
import DashboardRoutes from './routes/DashboardRoutes';
import Onboarding from './pages/Onboarding';
import Pricing from './pages/Pricing';

import ShopMenu from './pages/ShopMenu';
import ShopProfile from './pages/ShopProfile';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import BlogPreview from './pages/BlogPreview';
import PostsFeed from './pages/PostsFeed';
import BaristaDashboard from './pages/BaristaDashboard';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import NotFound from './pages/NotFound';
import AdminRoutes from './routes/AdminRoutes';


import RoleRoute from './components/RoleRoute';
import PublicRoute from './components/PublicRoute';
import OnboardingRoute from './components/OnboardingRoute';
import LanguageSelector from './components/LanguageSelector';
import SubscriptionBanner from './components/subscription/SubscriptionBanner';
import SubscriptionStatusListener from './components/SubscriptionStatusListener';
import './index.css';
import './i18n/i18n';
import './i18n/rtlManager';

function App() {
  return (
    <BrandProvider>
      <AuthProvider>
        <ShopProvider>
          <BillingProvider>
          <AdminProvider>
            <CurrencyProvider>
            <Router>
              <div className="min-h-screen bg-gradient-to-b from-[#1f2937] to-[#111827]">
                <SubscriptionStatusListener />
                <SubscriptionBanner />
                <div className="fixed top-4 right-4 z-[60]">
                  <LanguageSelector />
                </div>
                
                <Routes>
                  <Route path="/" element={<Landing />} />
                  <Route path="/pricing" element={<Pricing />} />
                  <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
                  <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
                  <Route path="/onboarding" element={<OnboardingRoute><Onboarding /></OnboardingRoute>} />
                  <Route path="/dashboard/*" element={<RoleRoute allowedRoles={['OWNER']} routeType="owner"><DashboardRoutes /></RoleRoute>} />
                  <Route path="/admin/*" element={<RoleRoute allowedRoles={['ADMIN']} routeType="admin"><AdminRoutes /></RoleRoute>} />

                  <Route path="/barista" element={
                    <RoleRoute allowedRoles={['BARISTA', 'OWNER']} routeType="barista">
                      <BaristaSettingsProvider>
                        <BaristaDashboard />
                      </BaristaSettingsProvider>
                    </RoleRoute>
                  } />
                  <Route path="/shop/:slug" element={<ShopProfile />} />
                  <Route path="/shop/:slug/table/:tableNumber" element={<ShopMenu />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/posts" element={<PostsFeed />} />
                  <Route path="/blog/preview" element={<BlogPreview />} />
                  <Route path="/blog/:slug" element={<BlogPost />} />
                  <Route path="/payment/success" element={<PaymentSuccess />} />
                  <Route path="/payment/cancel" element={<PaymentCancel />} />
                  
                  {/* 404 Catch-all route - must be last */}
                  <Route path="*" element={<NotFound />} />
                </Routes>
                <Toaster
                  position="top-right"
                  toastOptions={{
                    duration: 4000,
                    style: {
                      background: '#1f2937',
                      color: '#ffffff',
                      border: '1px solid #374151',
                    },
                  }}
                />
              </div>
            </Router>
            </CurrencyProvider>
          </AdminProvider>
        </BillingProvider>
      </ShopProvider>
    </AuthProvider>
    </BrandProvider>
  );
}

export default App;
